import { NativeInterfaceTransmit } from "./NativeInterfaceTransmit";
import { NativeInterfaceWebsocket } from "./NativeInterfaceWebsocket";
var NativeInterface = /** @class */ (function () {
    function NativeInterface() {
        var _this = this;
        this.listeners = {};
        this.transmitInterface = new NativeInterfaceTransmit(function (event) { return _this.routeEvent(event); });
        this.websocketInterface = new NativeInterfaceWebsocket(function (event) { return _this.routeEvent(event); });
    }
    NativeInterface.prototype.init = function () { };
    NativeInterface.prototype.addModule = function (module) {
        this.listeners[module.getPrefix()] = module;
    };
    NativeInterface.prototype.available = function () {
        return (typeof window.native !== 'undefined');
    };
    NativeInterface.prototype.request = function (event, timeout) {
        if (timeout === void 0) { timeout = 10 * 1000; }
        if (this.websocketInterface.isConnected())
            return this.websocketInterface.request(event, timeout);
        else
            return this.transmitInterface.request(event, timeout);
    };
    NativeInterface.prototype.routeEvent = function (event) {
        for (var modulePrefix in this.listeners) {
            if (event.name.indexOf(modulePrefix) === 0) {
                this.listeners[modulePrefix].onEvent({
                    name: event.name,
                    params: event.data,
                });
            }
        }
    };
    return NativeInterface;
}());
export { NativeInterface };
if (typeof window[NativeInterface.name] === 'undefined') {
    NativeInterface.instance = new NativeInterface();
    window[NativeInterface.name] = NativeInterface.instance;
}
else {
    NativeInterface.instance = window[NativeInterface.name];
}
//# sourceMappingURL=NativeInterface.js.map